import React from 'react';
import { ToastContainer } from 'react-toastify';

const PublicLayout = ({ component: Component }) => {
    return (
        <div className="main-wrapper" style={{ marginLeft: 0,paddingTop:0 }}>
            <div className="page-wrapper" style={{ marginLeft: 0 ,paddingTop:0}}>
                <div className="content container-fluid">
                    {Component}
                </div>
            </div>
            <ToastContainer />
        </div>
    )
};

export default PublicLayout;
